var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid d-flex justify-content-center align-items-center subscribe_layout"},[_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }